import { ChevronDown, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLang } from "./LanguageProvider";
import { HTML_LANG, LANGS, LANG_NAMES, isLang } from "./translate";

export function LanguagePicker() {
  const { lang, setLang, t } = useLang();
  return (
    <div className="mt-3">
      <div id="apply-lang-choose" className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
        {t("lang.choose")}
      </div>
      <div role="group" aria-labelledby="apply-lang-choose" className="flex flex-nowrap justify-center gap-1.5 overflow-x-auto">
        {LANGS.map((l) => (
          <Button
            key={l}
            type="button"
            size="sm"
            variant={l === lang ? "default" : "outline"}
            aria-pressed={l === lang}
            lang={HTML_LANG[l]}
            onClick={() => setLang(l)}
            className="shrink-0 px-2.5"
          >
            {LANG_NAMES[l]}
          </Button>
        ))}
      </div>
    </div>
  );
}

export function LanguageMenu() {
  const { lang, setLang, t } = useLang();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="ghost" size="sm" aria-label={`${t("lang.menu")}: ${LANG_NAMES[lang]}`} className="gap-1.5 px-2">
          <Globe className="h-4 w-4" aria-hidden="true" />
          <span lang={HTML_LANG[lang]}>{LANG_NAMES[lang]}</span>
          <ChevronDown className="h-3.5 w-3.5 opacity-60" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup value={lang} onValueChange={(v) => { if (isLang(v)) setLang(v); }}>
          {LANGS.map((l) => (
            <DropdownMenuRadioItem key={l} value={l} lang={HTML_LANG[l]}>
              {LANG_NAMES[l]}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
